import { Layout, Row, Col } from "antd";
import moment from "moment";
import { HeartFilled } from "@ant-design/icons";

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
          <div className="copyright">
            © {moment().year()}, made with
            {<HeartFilled />} by
            <a href="https://fireflynp.com/" className="font-weight-bold" target="_blank">
              Firefly Services Pvt. Ltd.
            </a>
            for a better web.
          </div>
        </Col>
        <Col xs={24} md={12} lg={12}>
          <div className="footer-menu">
            <ul>
              <li className="nav-item">
                <a
                  href="https://nagarikaawaz.org.np"
                  className="nav-link text-muted"
                  target="_blank"
                >
                  Nagarik Aawaz
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://nagarikaawaz.org.np/about/"
                  className="nav-link text-muted"
                  target="_blank"
                >
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://nagarikaawaz.org.np/1099-2/"
                  className="nav-link text-muted"
                  target="_blank"
                >
                  Publications
                </a>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
